<template>
  <div class="page-container">
   
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">其他功能</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>返佣配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <!-- <create @refresh="getList"></create> -->
        <el-input placeholder="请输入发放至账户ID" clearable v-model="userId">
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select placeholder="请选择coinType" clearable v-model="coinType">
         <el-option
         v-for="item in  allCoins"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
        </el-select>
        <el-date-picker
          v-model="value2"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions">
        </el-date-picker>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <a  @click="getExcel" target="_blank" >导出Excel</a>
      </div>
      <list @refresh="getList"></list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import List from './components/list';
import Create from './components/create';
import moment from 'moment';

export default {
  name: 'Commission',
  data() {
    return {
      userId: '',
      coinType:'',
      startTime:'',
      endTime:'',
       
      value2: '',
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
    };
  },
  components: {
    List,
    Create
  },
  computed: {
    ...mapState('commission', ['pagination','allCoins']),
    ...mapGetters('commission', ['list'])
  },
  methods: {
    ...mapActions('commission', ['reqList','exportExcel','getAllCoins']),
    handleSearch() {
         this.reqList({ 
          userId:this.userId,
          coinType:this.coinType,
          endTime: this.value2?this.value2[1].valueOf():'',
        startTime: this.value2?this.value2[0].valueOf():'',
          ...this.pagination });
    },
  
    getList(data = {}) {
      this.reqList({
        userId:this.userId,
        coinType:this.coinType,
        endTime: this.value2?this.value2[1].valueOf():'',
        startTime: this.value2?this.value2[0].valueOf():'',
        ...this.pagination,
        ...data
      });
    },
    getExcel(){
      this.exportExcel({
            endTime: this.value2?this.value2[1].valueOf():'',
            startTime: this.value2?this.value2[0].valueOf():'',
            userId:this.userId,
        coinType:this.coinType,
        }).then(res=>{
        const link=document.createElement('a') 
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
      link.style.display = 'none'
      // 设置连接
      link.href = URL.createObjectURL(blob)  //将文件流转化为blob地址
      console.log('link-href',link.href);
      link.download = '返佣报表'
      document.body.appendChild(link)
      // 模拟点击事件
      link.click()  //设置点击事件

      });
    }
  },
  created() {
 
    this.getList({
      userId:this.userId,
      coinType:this.coinType,
      startTime:this.startTime,
      endTime:this.endTime,
      ...this.pagination
    });
    this.getAllCoins()
  }
};
</script>

<style lang="less" scoped>
.actions-bar {
  display: flex;
  align-items: center;
}

.el-input {
  width: 300px;
}

.el-date-editor,
.el-input {
  margin-right: 10px;
}
</style>
